import React from 'react'
import { Button, Tooltip } from '@mui/material'

type PanelButtonBarProps = {
  onConfirm: () => void
  onCancel: () => void
  onDefault: () => void
  disableConfirm?: string
}

const PanelButtonBar = ({
  onCancel,
  onConfirm,
  onDefault,
  disableConfirm,
}: PanelButtonBarProps) => {
  return (
    <div className="flex items-start justify-around w-full py-4">
      <Tooltip
        title={disableConfirm}
        placement="top"
      >
        <span>
          <Button
            onClick={onConfirm}
            onKeyDown={(e) => {
              if (e.key === 'Enter') onConfirm()
            }}
            tabIndex={0}
            variant="contained"
            color="success"
            disabled={!!disableConfirm}
          >
            CONFIRMER
          </Button>
        </span>
      </Tooltip>
      <Button
        onClick={onCancel}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            e.stopPropagation()
            onCancel()
          }
        }}
        tabIndex={0}
        color="error"
        variant="contained"
      >
        ANNULER
      </Button>

      <Button
        onClick={onDefault}
        onKeyDown={(e) => {
          if (e.key === 'Enter') e.preventDefault()
          e.stopPropagation()
          onDefault()
        }}
        tabIndex={0}
        color="primary"
        variant="contained"
      >
        RÉINITIALISER
      </Button>
    </div>
  )
}

export default PanelButtonBar
